import React from "react";

interface ButtonMediumProps {
  icon?: string;
  className?: string;
  type?: "button" | "submit" | "reset" | undefined;
  onClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  disabled?: boolean;
}

const ButtonMedium: React.FC<ButtonMediumProps> = ({
  children,
  onClick,
  icon,
  className,
  type,
  disabled,
}) => {
  return (
    <button
      className={`flex items-center bg-accent text-text p-3 text-sm rounded-lg leading-none border hover:text-accent hover:bg-text active:bg-dark focus:outline-none transition ease-in-out duration-100 disabled:cursor-not-allowed disabled:bg-accent disabled:text-subtitle ${
        className ? className : ""
      }`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {icon && <i className="material-icons mr-4">{icon}</i>}
      <span className="font-medium">{children}</span>
    </button>
  );
};

export default ButtonMedium;
